var _path, _path2, _g, _path3, _path4, _rect, _rect2, _rect3, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBot12(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4878 61.4723C25 68.3175 25 77.2783 25 95.2V123.586H29V148C29 156.837 36.1634 164 45 164H135C143.837 164 151 156.837 151 148V123.586H155V95.2C155 77.2783 155 68.3175 151.512 61.4723C148.444 55.4511 143.549 50.5557 137.528 47.4878C130.683 44 121.722 44 103.8 44H76.2C58.2783 44 49.3175 44 42.4723 47.4878C36.4511 50.5557 31.5557 55.4511 28.4878 61.4723Z",
    fill: "#0076DE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_46",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 44,
    width: 130,
    height: 120
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4878 61.4723C25 68.3175 25 77.2783 25 95.2V123.586H29V148C29 156.837 36.1634 164 45 164H135C143.837 164 151 156.837 151 148V123.586H155V95.2C155 77.2783 155 68.3175 151.512 61.4723C148.444 55.4511 143.549 50.5557 137.528 47.4878C130.683 44 121.722 44 103.8 44H76.2C58.2783 44 49.3175 44 42.4723 47.4878C36.4511 50.5557 31.5557 55.4511 28.4878 61.4723Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_46)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 44,
    width: 134,
    height: 120,
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 124,
    width: 122,
    height: 40,
    fill: "black",
    fillOpacity: 0.8
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90 124H52.0002V145C52.0002 145 53.9529 156 64.8413 156C70.2547 156 73.7512 154.023 77.2674 152.034C79.6499 150.686 82.0415 149.334 85.0446 148.588C87.7142 147.925 89.9826 145.778 90.0001 143.032C90.0177 145.778 92.2861 147.925 94.9556 148.588C97.9588 149.334 100.35 150.686 102.733 152.034C106.249 154.023 109.746 156 115.159 156C126.047 156 128 145 128 145V124H90.0002H90Z",
    fill: "#F6E3D0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M82 132C82 136.418 85.5817 140 90 140C94.4183 140 98 136.418 98 132",
    stroke: "#A75548",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 48,
    transform: "translate(38 76)",
    fill: "#9F9F9F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 92,
    width: 91,
    height: 16,
    rx: 4,
    fill: "black",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_0_46",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 92,
    width: 91,
    height: 16
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 92,
    width: 91,
    height: 16,
    rx: 4,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_0_46)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114 83H132L120 113H102L114 83Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90 83H99L87 113H78L90 83Z",
    fill: "white",
    fillOpacity: 0.8
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBot12);
export default __webpack_public_path__ + "static/media/bot-12.08cf32cd3e3d1eab6f331682ef6b23bc.svg";
export { ForwardRef as ReactComponent };